<template>
  <div id="app">
    <!-- <Loading :loading-show="loadingShow"></Loading> -->
    <LoadingMid
      :loading-show="midLoadingShow"
      :text="midLoadingText"
    ></LoadingMid>
    <!-- Toast -->
    <Toast :toast-show="toastShow" :text="toastText"></Toast>
    <!-- AddToHome -->
    <AddToHome></AddToHome>
    <!-- Login -->
    <Login></Login>
    <!-- LoginDetail -->
    <LoginDetail></LoginDetail>
    <!-- form -->
    <div>
      <form :action="paypalUrl" method="post" target="_top" id="post-form">
        <!-- https://www.paypal.com/cgi-bin/webscr -->
        <!-- https://www.sandbox.paypal.com/cgi-bin/webscr -->
        <input type="hidden" name="cmd" value="_s-xclick" />
        <input
          type="hidden"
          name="hosted_button_id"
          :value="postData.button_id"
        />
        <input type="hidden" name="custom" :value="postData.custom" />
      </form>
    </div>
    <!-- top nav -->
    <nav v-if="web_navbar_show">
      <WebTopBar
        :title-name="navName"
        :user-img="webNavImg"
        :collect-show="collectShow"
        :img-show="navImgShow"
        :account-show="accountShow"
      ></WebTopBar>
    </nav>
    <!-- main content -->
    <main>
      <router-view></router-view>
    </main>

    <!-- Ads -->
    <!-- <Ads v-show="androidAdsShow"></Ads> -->

    <!-- web-bar -->
    <footer v-if="webTabbarShow">
      <div class="footer-inner">
        <div
          style="position:fixed;bottom:0;left:0;z-index:10"
          class="tabbar-bottom"
        >
          <a :class="{ active: tabSeleced == 'follow' }" @click="followClick">
            <img
              src="./assets/icon/image_tabar_followers@3x.png"
              v-show="tabSeleced != 'follow'"
            />
            <img
              src="./assets/icon/image_tabar_followers_selceted@3x.png"
              v-show="tabSeleced == 'follow'"
            />
            <span>Followers</span>
          </a>
          <a :class="{ active: tabSeleced == 'like' }" @click="likeClick">
            <img
              src="./assets/icon/image_tabar_like@3x.png"
              v-show="tabSeleced != 'like'"
            />
            <img
              src="./assets/icon/image_tabar_like_selceted@3x.png"
              v-show="tabSeleced == 'like'"
            />
            <span>Likes</span>
          </a>
          <a
            :class="{ active: tabSeleced == 'subscription' }"
            @click="subscriptionClick"
          >
            <img
              src="./assets/icon/image_tabar_sub@3x.png"
              v-show="tabSeleced != 'subscription'"
            />
            <img
              src="./assets/icon/image_tabar_sub_selceted@3x.png"
              v-show="tabSeleced == 'subscription'"
            />
            <span>Subscriptions</span>
            <i>NEW</i>
          </a>
          <a :class="{ active: tabSeleced == 'more' }" @click="moreClick">
            <img
              src="./assets/icon/image_tabar_more@3x.png"
              v-show="tabSeleced != 'more'"
            />
            <img
              src="./assets/icon/image_tabar_more_selected@3x.png"
              v-show="tabSeleced == 'more'"
            />
            <span>More</span>
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import TopBar from "./components/common/TopBar.vue";
import LoadingMid from "./components/common/LoadingMiddle.vue";
import Toast from "./components/common/Toast.vue";
// import Ads from "./components/common/AdsBottom.vue";
import WebTopBar from "./components/common/WebNavBar.vue";
import LoginDetail from "./components/common/LoginDetail.vue";
// import AdsTop from "./components/common/AddTop.vue";
import AddToHome from "./components/common/AddToHome.vue";
import Login from "./components/common/Login.vue";
import { paypalUrl } from "./config/env.js";
export default {
  name: "app",
  data() {
    return {
      paypalUrl: paypalUrl
    };
  },
  computed: {
    urlData() {
      return this.$store.state.urlData;
    },
    getType() {
      return this.$store.state.getType;
    },
    routerLink() {
      return this.$store.state.dataUrl;
    },
    WebrouterLink() {
      return this.$route.params.userName + "/" + this.$route.params.userId;
    },
    tabSeleced() {
      return this.$store.state.tabSeleced;
    },
    loadingShow() {
      return this.$store.state.loadingShow;
    },
    midLoadingShow() {
      return this.$store.state.midLoadingShow;
    },
    postData() {
      return this.$store.state.postData;
    },
    navName() {
      return this.$store.state.navTitleName;
    },
    tabbarShow() {
      return this.$store.state.tabbarShow;
    },
    coinShow() {
      return this.$store.state.coinShow;
    },
    collectShow() {
      return this.$store.state.collectShow;
    },
    toastShow() {
      return this.$store.state.toastShow;
    },
    toastText() {
      return this.$store.state.toastText;
    },
    webTabbarShow() {
      return this.$store.state.web_tabbar_show;
    },
    midLoadingText() {
      return this.$store.state.midLoadingText;
    },
    navbarShow() {
      return this.$store.state.navbarShow;
    },
    web_navbar_show() {
      return this.$store.state.web_navbar_show;
    },
    navImgShow() {
      return this.$store.state.web_navimg_show;
    },
    webNavImg() {
      if (JSON.stringify(this.$store.state.userInfo) == "{}") {
        return "";
      } else {
        return this.$store.state.userInfo.user.profile_pic_url;
      }
    },
    accountShow() {
      return this.$store.state.web_account_show;
    },
    iosAdsShow() {
      return this.$store.state.web_safari_ads_show;
    },
    androidAdsShow() {
      return this.$store.state.web_android_ads_show;
    }
  },
  components: {
    TopBar,
    LoadingMid,
    Toast,
    Ads: () => import("./components/common/AdsBottom.vue"),
    WebTopBar,
    // AdsTop,
    AddToHome,
    Login,
    LoginDetail
  },
  mounted() {
    document.getElementById("start-loading").style.cssText = "display:none"; //隐藏首次加载动画
    if (navigator.userAgent.match(/Android/i)) {
      //安卓系统

      var body = document.getElementsByTagName("body")[0];
      body.setAttribute("class", "android-8");
    }
  },
  methods: {
    followClick() {
      this.$router.push({
        name: "follow",
        params: {
          userName: this.$route.params.userName,
          userId: this.$route.params.userId
        }
      });

      ga("set", "page", "/follow.html");
      ga("send", "pageview");
    },
    likeClick() {
      this.$router.push({
        name: "like",
        params: {
          userName: this.$route.params.userName,
          userId: this.$route.params.userId
        }
      });

      ga("set", "page", "/like.html");
      ga("send", "pageview");
    },
    subscriptionClick() {
      this.$router.push({
        name: "subscription",
        params: {
          userName: this.$route.params.userName,
          userId: this.$route.params.userId
        }
      });

      ga("set", "page", "/subscriptions.html");
      ga("send", "pageview");
    },
    moreClick() {
      this.$router.push({
        name: "more",
        params: {
          userName: this.$route.params.userName,
          userId: this.$route.params.userId
        }
      });

      ga("set", "page", "/more.html");
      ga("send", "pageview");
    }
  }
};
</script>

<style lang="less">
@import "style/Common.less";
body,
html {
  background-color: #f1f2f4;
  height: 100%;
  width: 100%;
}

#app {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  min-height: 100%;
}

nav {
  height: 40px;
  order: 2;
  top: 0;
  z-index: 100;
}

main {
  flex-grow: 1;
  order: 3;
  position: relative;
  //  overflow: hidden;
}
footer {
  order: 5;
  height: 50px;
  .footer-inner {
    height: 50px;
    .tabbar-bottom {
      img {
        width: 22px !important;
        height: auto !important;
        margin-top: 4px;
        margin-bottom: 0px;
      }
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 50px;
      border-top: 1px solid #ddd;
      a {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        flex: 1;
        height: 50px;
        flex-direction: column;
        color: rgba(0, 0, 0, 0.53);
        font-size: 12px;
        position: relative;
        span {
          display: block;
        }
        i {
          //tab的标签
          display: block;
          width: 34px;
          height: 14px;
          background: rgb(237, 73, 86);
          font-size: 9px;
          color: #fff;
          line-height: 14px;
          text-align: center;
          position: absolute;
          right: 11%;
          top: 5px;
          border-radius: 2px;
          font-style: normal;
          font-family: arial;
        }
      }
      a.active {
        color: rgb(0, 170, 238);
      }
    }
  }
}

.tabbar-enter-active {
  animation: slide-up 0.5s;
}
.tabbar-leave-active {
  animation: slide-down 0.5s;
}
@keyframes slide-up {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0%);
  }
}
@keyframes slide-down {
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(100%);
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?825678cc